import React, { useEffect } from 'react'
import { useSelector } from 'react-redux'
import {
  withStyles,
  Accordion,
  AccordionSummary,
  AccordionDetails,
  Typography,
} from '@material-ui/core'
import { styled } from '@material-ui/core'
import styles from '../styles'
import { AccordionSummaryContent } from '..'
import UserType from 'src/model/user-types'

import { PatchData, PatchContent } from 'src/model/patch'
import { patchCollectionSettingsAction } from 'src/reducers/collection/action'
import { useDispatch } from 'react-redux'
import { Icon } from '@iconify/react'
import { CoreButton } from 'src/components/core'
import PaidAccess from './components/paid-access'
import { messageBoxShowAction } from 'src/reducers/message-box/action'
import MessageBoxContent, { MessageBoxType } from 'src/model/message-box'

const StyledAccordion = styled(Accordion)(({ theme }) => ({
  width: '100%',
  '&.Mui-expanded': {
    boxShadow: 'none',
  },
}))

const PaymentWall = props => {
  const {
    accessRule,
    handleAccessRule,
    classes,
    setPaymentLink,
    setPaymentProvider,
    paymentProvider,
    paymentSettingsConfigured,
    setPaymentSettingsConfigured,
    paymentLink,
    modal,
    collectionId,
    onClickEdit,
  } = props
  const dispatch = useDispatch()
  const entity = useSelector(state => state.collection.collection)
  const userControl = UserType[window.CONSTANTS.USER_ROLE_ID]

  const accessSpecificUsersControl = () => {
    if (
      userControl == 'Premium Plus' ||
      userControl == 'Premium Plus v2' ||
      userControl == 'Premium - A' ||
      userControl == 'Premium' ||
      userControl == 'Premium v2' ||
      userControl == 'AppSumo (Tier 2)' ||
      userControl == 'AppSumo (Tier 2A)' ||
      userControl == 'AppSumo (Tier 3)' ||
      userControl == 'AppSumo (Tier 3A)' ||
      userControl == 'AppSumo (Tier 4)' ||
      userControl == 'AppSumo (Tier 5)' ||
      userControl == 'Elite' ||
      userControl == 'AppSumo (Tier 6)' ||
      userControl == 'AppSumo (Tier 7)' ||
      userControl == 'AppSumo (Tier 8)' ||
      userControl == 'AppSumo (Tier 9)' ||
      userControl == 'Pro' ||
      userControl == 'Plus' ||
      userControl == 'Pro v2' ||
      userControl == 'Launch' ||
      userControl == 'Essentials' ||
      userControl == 'Growth' ||
      userControl == 'Scale' ||
      userControl == 'Enterprise' ||
      UserType.isTrialEquivalent(userControl)
    ) {
      return false
    }
    return true
  }

  const onClickDoneLocal = clickedBeforeFinish => {
    const patchSource = new PatchData(
      null,
      collectionId ? collectionId : entity.id,
    )
    patchSource.addContent(
      new PatchContent(
        true,
        'isPaymentConfigured',
        PatchData.OPERATION_REPLACE,
      ),
    )
    dispatch(
      patchCollectionSettingsAction(patchSource, response => {
        !clickedBeforeFinish && setPaymentSettingsConfigured(true)
      }),
    )
  }

  const [anchorEl, setAnchorEl] = React.useState(null)

  const handleClick = event => {
    setAnchorEl(event.currentTarget)
  }

  const handleClose = () => {
    setAnchorEl(null)
  }

  const open = Boolean(anchorEl)
  const id = open ? 'simple-popover' : undefined

  const openPaidAccessModal = () => {
    dispatch(
      messageBoxShowAction(
        MessageBoxContent({
          type: MessageBoxType.WARNING,
          buttons: [],
          title: 'Learners authentication',
          maxWidth: '880px',
          component: (
            <PaidAccess
              collectionId={collectionId}
              paymentProvider={paymentProvider}
              paymentSettingsConfigured={paymentSettingsConfigured}
              entity={entity}
              paymentLink={paymentLink}
              setPaymentLink={setPaymentLink}
              setPaymentSettingsConfigured={setPaymentSettingsConfigured}
              setPaymentProvider={setPaymentProvider}
              onClickDone={onClickDoneLocal}
            />
          ),
        }),
      ),
    )
  }

  const handleClickSwitch = event => {
    if (accessSpecificUsersControl()) {
      handleClick(event)
    } else {
      handleAccessRule(4)
    }
  }

  return (
    <div className={classes.root}>
      <StyledAccordion expanded={accessRule == 4}>
        <AccordionSummary
          className={classes.accordion__summary}
          aria-controls="panel1bh-content"
          id="panel1bh-header"
        >
          <AccordionSummaryContent
            accessRule={accessRule}
            handleClickSwitch={handleClickSwitch}
            contentHeader={'Paid access'}
            contentDescription={'Grant access after payment'}
            id={id}
            badgeType={4}
            open={open}
            anchorEl={anchorEl}
            handleClose={handleClose}
            popupHeader={'Upgrade to Plus'}
            popupContent={
              'Upgrade to Plus plan to access advanced features.'
            }
            accessRuleEqual={4}
          />
        </AccordionSummary>
        <AccordionDetails className={classes.accordion__details}>
          <CoreButton
            variant="contained"
            color="primary"
            onClick={() => {
              onClickEdit && onClickEdit()
            }}
          >
            Edit Paid Access
          </CoreButton>
        </AccordionDetails>
      </StyledAccordion>
    </div>
  )
}

export default withStyles(styles)(PaymentWall)
